import React from "react"
import { FormattedDate, FormattedMessage } from "react-intl"
import { Link } from "react-router-dom"
import Location from "../../../src/state/location/Location"
import Icon from "../../common/icon/icon.component"
import PaymentAccount from "../../payment-account/model/paymentaccount"
import { PAYMENT_ACCOUNT_STATUS } from "../../utils"
import PaymentAccountBadge from "../components/PaymentAccountBadge"

const uuidv4 = require("uuid/v4")

export const generateHeaders = () => {
    return [
        <FormattedMessage
            id="payment_account_listing.name.header"
            defaultMessage="Name"
            key={uuidv4()}
        />,
        <FormattedMessage
            id="payment_account_listing.locations.header"
            defaultMessage="Location(s)"
            key={uuidv4()}
        />,
        <FormattedMessage
            id="payment_account_listing.application_status.header"
            defaultMessage="Application Status"
            key={uuidv4()}
        />,
        <FormattedMessage
            id="payment_account_listing.account_status.header"
            defaultMessage="Account Status"
            key={uuidv4()}
        />,
        <FormattedMessage
            id="payment_account_listing.activated_at.header"
            defaultMessage="Activated At"
            key={uuidv4()}
        />,
        "",
    ]
}

export const generateRows = (rowData: PaymentAccount,
    locations : Location[] | undefined,
    setShowModal : (bool : boolean) => void,
    setCurrentLocationIds : (locationsIds : string[]) => void,
    setPaymentAccountMerchantId : (id : string) => void) => {
    const link = rowData.getStatus() != PAYMENT_ACCOUNT_STATUS.PENDING ? <div>{rowData.getName()}</div> :
        <Link to={`/payment-accounts/${rowData.getId()}/edit`} key={`${rowData.getId()}`}>
            {rowData.getName()}
        </Link>
    const date = rowData.getActivatedAt() !== "" ?
        <FormattedDate
            key={`${rowData.getActivatedAt()}-activated_at`}
            year="numeric"
            month="long"
            day="numeric"
            value={rowData.getActivatedAt()}/> : "-"
    const locationsNames = rowData.getLocationIds().length > 0 ? locations?.filter(location => rowData.getLocationIds()
        .includes(location.getId()))
        .map(location => location.getName())
        .join(", ") : <FormattedMessage
        id="payment_account_listing.all_unassigned_locations"
        defaultMessage="All unassigned locations"
    />
    return [
        link,
        locationsNames
        ,
        <PaymentAccountBadge
            status={rowData.getOnboardingStatus()}
            key={`${rowData.getId()}-application_status`}
        />,
        <PaymentAccountBadge
            status={rowData.getStatus()}
            key={`${rowData.getId()}-account_status`}
        />,
        date,
        <button onClick={() => {
            setShowModal(true)
            setCurrentLocationIds(rowData.getLocationIds())
            setPaymentAccountMerchantId(rowData.getMerchantId())
        }}
        key={`${rowData.getId()}-edit-modal-button`}
        className="btn btn-outline-primary mr-2 mb-2"
        style={{ border: "none" }}>
            <Icon value={"edit"} className={"mr-1"} />
        </button>
    ]
}


// WEBPACK FOOTER //
// ./src/payment-processing/payment-account-listing/PaymentAccountListingHelper.tsx